export const  getPhaseById=  (phaseId,steps)=> {			
	for (var i = 0; i < steps.length; i++)	{
		var phases = steps[i].phases;
		for (var j = 0; j < phases.length; j++)	{
			if (phases[j].id == phaseId)	{
				return phases[j];
			}
		}
	}
	return null;
}

export const getPhaseByStepAndPhaseNumber =  (stepNumber, phaseNumber,steps)=> {
			var step = getStepByNumber(stepNumber,steps);
	for (var i = 0; i < step.phases.length; i++) {
		if (step.phases[i].phaseNumber == phaseNumber) {
			return step.phases[i];
		}
	}
	return null;
}

export const getStepByPhaseId = (phaseId,steps) =>	{				
	for (var i = 0; i < steps.length; i++)	{
		for (var j = 0; j < steps[i].phases.length; j++)	{
			if (steps[i].phases[j].id == phaseId)	{
				return steps[i];
			} 
		}
	}
}

const getStepByNumber = (number,steps) =>	{			
	return steps.find(step => step.stepNumber == number) || null;
}

export const getCurrentStep = (workflow) => {
	var status = workflow.status;
	var steps = workflow.steps;
	if (status === 'COMPLETED')	{
		return null;
	}
	
	var currentStepId = workflow.currentStepId;
	
	if (currentStepId == null)	{
		return null;
	}
	
	for (var i = 0; i < steps.length; i++)	{
		if (steps[i].id == currentStepId)	{
			return steps[i];
		}
	}
	return null;
}
		
export const getNextReviewPhaseInStepIfExists = (currentPhaseId, workflowResource) => {
	var thisPhase = getPhaseById(currentPhaseId, workflowResource.resource.steps);
	if(thisPhase.phaseType.code !== "review") {
		return null;
	}
	var thisStep = getCurrentStep(workflowResource.resource);
	const phase = thisStep.phases[thisPhase.phaseNumber];
	return phase !== undefined ? phase : null;
}

export const getPhaseByPhaseId = (step, phaseId) => {
	var phases = step.phases;
	for (var i = 0; i < phases.length; i++)	{
		if (phases[i].id == phaseId)	{
			return phases[i];
		}
	}
}

export const getCurrentPhase = (workflowResource) => {
	var currStep = getCurrentStep(workflowResource);
	return (currStep != null) ? getPhaseByPhaseId(currStep, workflowResource.currentPhaseId) : null;
}

export const getFirstPhaseOfStep = (stepNumber, steps) => {
	var step = getStepByNumber(stepNumber, steps);
	if (step == null)	{
		return null;
	}
	return step.phases[0];
}

export const getNextWorkPhaseIfExists = (workflowResource, currentPhaseId) => {
    const steps = workflowResource.resource.steps;
    let thisStep, thisPhase;

    for (const step of steps) {
        for (const phase of step.phases) {
            if (phase.id === currentPhaseId) {
                thisStep = step;
                thisPhase = phase;
                break;
            }
        }
        if (thisStep && thisPhase) break;
    }

    if (!thisStep || !thisPhase) return null;

    const nextPhase = thisStep.phases[thisPhase.phaseNumber];
    if (nextPhase) return null;

    return getFirstPhaseOfStep(thisStep.stepNumber + 1, steps);
};

export const getAssigneeForPhase = (phase) => {
	if(phase.assigneeDisplay) {
		return phase.assigneeDisplay;
	}
	var assignee = null;
	
	if((phase.assigneeType.code == "customer_user") && (phase.assigneeUser != null)) {
		assignee = phase.assigneeUser.firstName + " " + phase.assigneeUser.lastName;
	} else if ((phase.assigneeType.code == "vendor") && (phase.assigneeVendor != null)) {
		assignee = phase.assigneeVendor.name;
	}
	return assignee;
}